import produce from "immer"

const initialState = {}

const user = produce((draft = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGIN_REQUEST':
      return {
        loggingIn: true,
      }
    case 'USER_LOGIN_SUCCESS':
      return {
        loggedIn: true,
        user: action.payload.user,
        userId: action.payload.userId,
        accessToken: action.payload.accessToken
      }
    case 'USER_LOGIN_FAILURE':
      return {}
    case 'USER_SET_TOKEN':
      draft.accessToken = action.payload.accessToken
      return draft
    case 'USER_LOGOUT':
      return {}
    default:
      return draft
  }
})

export default user
